// extracted by mini-css-extract-plugin
export var legendIndicator = "_g7-1";
export var legendRight = "_g7-0";